import React, { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';

import Intro from './Intro';
import CostIntro from './CostIntro';
import FixedCosts from './FixedCost';
import VariableCost from './VariableCost';

import RevenueIntro from './RevenueIntro';
import RevenueModel from './RevenueModel';
import Pricing from './Pricing';
import ProjectedSales from './ProjectedSales';
import Summary from './Summary';

import Section from '../../components/Section';
import * as AppRoute from '../../utils/appRoutes';
import { prepareComponents } from '../../utils/helpers';
import { select } from '../../rematcher/store';

const components = [
  Intro,
  CostIntro,
  FixedCosts,
  VariableCost,
  RevenueIntro,
  RevenueModel,
  Pricing,
  ProjectedSales,
  Summary,
];

function CostRevenue({
  locales,
  locales: {
    costRevenue: { name, menu, sectionName },
  },
  progress,
}) {
  const {
    cost: { fetchCosts },
    product: { fetchProducts },
    revenue: { fetchRevenues },
    bmc: { fetchCurrentBmc },
  } = useDispatch();

  const { bmcId } = useParams();
  const preparedComponents = prepareComponents(
    components,
    bmcId,
    menu,
    AppRoute.costRevenue,
  );

  const getData = useCallback(() => {
    fetchCurrentBmc(bmcId);
    fetchCosts(bmcId);
    fetchProducts(bmcId);
    fetchRevenues(bmcId);
  }, [bmcId, fetchCurrentBmc, fetchCosts, fetchProducts, fetchRevenues]);

  useEffect(() => {
    getData();
  }, []);

  return (
    <Section
      components={preparedComponents}
      sectionName={sectionName}
      sectionLocaleName={name}
      menuItems={menu}
      progress={progress}
      locales={locales}
      finalDestination={AppRoute.bmc(bmcId)}
      onComponentChange={getData}
    />
  );
}

const mapState = select((models) => ({
  progress: models.progress.costRevenueProgress,
}));

export default connect(mapState, null)(CostRevenue);
